export enum EntitlementType {
    Return = "Return",
    Warranty = "Warranty",
}
